const replaceAll = (text, char, replace) => {
    const re = new RegExp(char, 'g');
    return text.replace(re, replace);
};
const copyToClipboard = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy);
};
const MIN_BALANCE_VALUE = 0.0001;
const WITHOUT_DECIMAL_VALUE = 1000;
const MAX_BALANCE_VALUE = 1000000;
const PRECISION_FLOOR_DIVIDER = 1 / MIN_BALANCE_VALUE;
const roundBalance = (balanceString) => {
    const clearedBalance = parseFloat(replaceAll(balanceString, '"', ''));
    if (clearedBalance > MAX_BALANCE_VALUE) {
        const dividedValue = Math.floor(clearedBalance);
        const roundedBalance = Math.floor((dividedValue / MAX_BALANCE_VALUE) * PRECISION_FLOOR_DIVIDER) /
            PRECISION_FLOOR_DIVIDER;
        return `${roundedBalance}M`;
    }
    if (clearedBalance > WITHOUT_DECIMAL_VALUE) {
        return String(Math.floor(clearedBalance));
    }
    if (clearedBalance < MIN_BALANCE_VALUE && clearedBalance > 0)
        return `< ${MIN_BALANCE_VALUE}`;
    const roundedBalance = Math.floor(clearedBalance * PRECISION_FLOOR_DIVIDER) /
        PRECISION_FLOOR_DIVIDER;
    if (roundedBalance === 0)
        return '0.0';
    return String(roundedBalance);
};
const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export { capitalize, copyToClipboard, replaceAll, roundBalance };
